// import React from "react";
// import { CiBellOn } from "react-icons/ci";
// import logo from "../assets/images/logo.png";
// import profile from "../assets/images/profile.png";

// export const Topbar = ({ toggleSidebar }) => {
//   return (
//    <div >

//      <div className="navbar-container">
//       {/* Hamburger Menu (Only Visible on Small Screens) */}
//       {window.innerWidth < 992 && (
//         <button onClick={toggleSidebar} className="hamburger-menu">
//           ☰
//         </button>
//       )}

//       <div style={{ display: "flex", justifyContent: "space-between" }}>
//         <div className="logo-img">
//           <img src={logo} />
//         </div>
//         <div className="nav-profileContainer">
//           <div className="bell-container">
//             <span className="bell-icon">
//               <CiBellOn />
//             </span>
//             <span className="bell-count">2</span>
//           </div>
//           <div className="nav-profile">
//             <img src={profile} />
//           </div>
//         </div>
//       </div>
//     </div>
//    </div>
//   );
// };


import React from "react";
import logo from "../assets/images/logo.png";
import profile from "../assets/images/profile.png";
import Dropdown from "react-bootstrap/Dropdown";
import { BsThreeDotsVertical } from "react-icons/bs";
import profilePlaceholder from "../assets/images/profile-placeholder.jpg";

export const Topbar = ({ toggleSidebar }) => {
    const user = JSON.parse(sessionStorage.getItem("user"));
     function handleLogout() {
    // Clear localStorage
    localStorage.clear();

    // Clear sessionStorage (optional but common)
    sessionStorage.clear();

    // Clear all cookies
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    // Clear cache storage (for service workers or PWA)
    if ("caches" in window) {
      caches.keys().then(function (names) {
        for (let name of names) caches.delete(name);
      });
    }

    // Optional: Clear any in-memory state or Redux store here

    // Hard reload to force everything to reset
    window.location.href = "/";
  }
  return (
    <div
    //   style={{
    //     background: "#333",
    //     padding: "10px",
    //     color: "#fff",
    //     display: "flex",
    //     alignItems: "center",
    //     justifyContent: "space-between",
   
    //   }}
    className="navbar-container"
    >
      {/* Hamburger Menu (Only Visible on Small Screens) */}
      {window.innerWidth < 992 && (
        <button
          onClick={toggleSidebar}
          style={{
            background: "transparent",
            border: "none",
            color: "black",
            fontSize: "24px",
            cursor: "pointer",
          }}
          className="hamburger-menu"
        >
          ☰
        </button>
      )}

      <div className="navbar-logoContainer">
        <div className="navLogo"><img src={logo}/></div>
        <div className="profile-container">
        <span>
          <img src={profilePlaceholder} />
        </span>
        <span className="nav-profileName">
          {user?.first_name || "Admin"}
        </span>
        <span>
          <Dropdown>
            <Dropdown.Toggle className="dropdown-btnDot" id="dropdown-basic">
              <BsThreeDotsVertical />
            </Dropdown.Toggle>

            <Dropdown.Menu className="dropdown-dots ">
              <div onClick={handleLogout}>Logout</div>
            </Dropdown.Menu>
          </Dropdown>
        </span>
      </div>
      </div>
    </div>
  );
};
